import { FormattedMessage } from 'react-intl'

const addingReview = (values) => {
  const errors = {}

  if(!values.text) {
    errors.text = (
      <FormattedMessage
        id='required_field'
        defaultMessage='This field is required!'
      />
    )
  }
  if(!values.certificationLevel) {
    errors.certificationLevel = (
      <FormattedMessage
        id='required_field'
        defaultMessage='This field is required!'
      />
    )
  }

  if(!values.username) {
    errors.username = (
      <FormattedMessage
        id='required_field'
        defaultMessage='This field is required!'
      />
    )
  }

  if(!values.isOwnAgreement) {
    errors.isOwnAgreement = (
      <FormattedMessage
        id='required_field'
        defaultMessage='This field is required!'
      />
    )
  }
  return errors
}

const addingReport = (values) => {
  const errors = {}

  if(!values.reason) {
    errors.reason = (
      <FormattedMessage
        id='required_field'
        defaultMessage='This field is required!'
      />
    )
  }
  if(!values.email) {
    errors.email = (
      <FormattedMessage
        id='required_field'
        defaultMessage='This field is required!'
      />
    )
  }
  return errors
}

export { addingReport, addingReview }
